(function () {
  'use strict';

  var DEFAULT_STORAGE_KEY = 'bundle_bar_items';
  function isSingleLine(ci) {
    return !!(ci && ci.properties && ci.properties._single);
  }
var _suppressBundleCartAdd = false;
var _justAddedToBundle = false; 
Object.defineProperty(window, '_justAddedToBundle', {
  get: function() { return _justAddedToBundle; },
  set: function(v) { _justAddedToBundle = v; },
  configurable: true 
});

  function loadFromStorage(key) {
    try { return JSON.parse(localStorage.getItem(key) || '[]'); }
    catch (e) { return []; }
  }
  function saveToStorage(key, items) {
    try { localStorage.setItem(key, JSON.stringify(items)); }
    catch (e) {}
  }
  function clearStorage(key) {
    try { localStorage.removeItem(key); }
    catch (e) {}
  }

  // ── "Sold as a set" confirmation modal ──
  // Used only for non-BXGY bundles (e.g. socks). Shown when removing a
  // committed item would drop the bundle below cfg.min. Nothing touches the
  // cart until the user confirms — this closes the race where the old
  // demote-then-async-clear flow left a single sock genuinely in the cart
  // (and checkout-able) for a couple seconds before it got pulled back out.
  var _minConfirmStylesInjected = false;
  function ensureMinConfirmModal() {
    var modal = document.getElementById('bundle-bar-min-modal');
    if (modal) return modal;

    if (!_minConfirmStylesInjected) {
      _minConfirmStylesInjected = true;
      var style = document.createElement('style');
      style.id = 'bundle-bar-min-modal-styles';
      style.textContent =
        '#bundle-bar-min-modal { display: none; position: fixed; inset: 0; z-index: 999999; }' +
        '.bundle-bar-min-modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.45); display: flex; align-items: center; justify-content: center; padding: 16px; }' +
        '.bundle-bar-min-modal-box { background: #fff; border-radius: 12px; padding: 24px; max-width: 360px; width: 100%; text-align: center; font-family: inherit; }' +
        '.bundle-bar-min-modal-box h3 { font-size: 16px; font-weight: 800; margin: 0 0 8px; color: #1a1a1a; }' +
        '.bundle-bar-min-modal-box p { font-size: 13px; color: #555; margin: 0 0 20px; }' +
        '.bundle-bar-min-modal-actions { display: flex; gap: 10px; }' +
        '.bundle-bar-min-modal-cancel, .bundle-bar-min-modal-remove { flex: 1; padding: 10px 0; border-radius: 8px; font-size: 13px; font-weight: 700; cursor: pointer; border: 2px solid #1a1a1a; }' +
        '.bundle-bar-min-modal-cancel { background: #fff; color: #1a1a1a; }' +
        '.bundle-bar-min-modal-remove { background: #1a1a1a; color: #fff; }';
      document.head.appendChild(style);
    }

    modal = document.createElement('div');
    modal.id = 'bundle-bar-min-modal';
    document.body.appendChild(modal);
    return modal;
  }

  function showMinConfirm(cfg, onConfirm, onCancel) {
    var modal = ensureMinConfirmModal();
    var title = (cfg.singleItemWarning && cfg.singleItemWarning.title) || "These aren't sold individually";
    var message = (cfg.singleItemWarning && cfg.singleItemWarning.message) ||
      ('You need at least ' + cfg.min + ' to checkout. Removing this one will remove its pair too.');

    modal.innerHTML =
      '<div class="bundle-bar-min-modal-overlay">' +
        '<div class="bundle-bar-min-modal-box">' +
          '<h3>' + title + '</h3>' +
          '<p>' + message + '</p>' +
          '<div class="bundle-bar-min-modal-actions">' +
            '<button type="button" class="bundle-bar-min-modal-cancel">Cancel</button>' +
            '<button type="button" class="bundle-bar-min-modal-remove">Remove Both</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    modal.style.display = 'block';

    var cancelBtn = modal.querySelector('.bundle-bar-min-modal-cancel');
    var removeBtn = modal.querySelector('.bundle-bar-min-modal-remove');

    function cleanup() {
      modal.style.display = 'none';
      cancelBtn.removeEventListener('click', onCancelClick);
      removeBtn.removeEventListener('click', onRemove);
    }
    function onCancelClick() { cleanup(); if (typeof onCancel === 'function') onCancel(); }
    function onRemove() { cleanup(); onConfirm(); }

    cancelBtn.addEventListener('click', onCancelClick);
    removeBtn.addEventListener('click', onRemove);
  }

  // Older/legacy stored items won't have a `committed` flag — they were all
  // added straight to the real cart under the old behavior, so treat them as such.
  function normalizeCommitted(items) {
    items.forEach(function (it) {
      if (typeof it.committed === 'undefined') it.committed = true;
    });
    return items;
  }

  // Strip any item whose variantId isn't allowed on this page's config.
  // This self-heals against cross-bar contamination (e.g. shared/legacy storage keys).
  function filterToAllowed(items, cfg) {
    if (!cfg.allowedVariantIds || !cfg.allowedVariantIds.length) return items;
    return items.filter(function (item) {
      return cfg.allowedVariantIds.indexOf(parseInt(item.variantId, 10)) !== -1;
    });
  }

 function reconcileWithCart(storedItems, cartItems, cfg) {
  // Build a map of variantId → cart quantity, and variantId → cart item data
  var cartQtyMap = {};
  var cartDataMap = {};
  cartItems.forEach(function (ci) {
    if (isSingleLine(ci)) return;
    var vid = String(ci.variant_id);
    cartQtyMap[vid] = ci.quantity;
    cartDataMap[vid] = ci;
  });

  // For each variant in selected, only keep up to cart quantity of that variant.
  // Items that aren't committed yet (still under the min-qty threshold) were
  // never added to the real cart, so cart quantity doesn't apply to them —
  // always keep them as-is.
  var countMap = {};
  var result = storedItems.filter(function (item) {
    if (!item.committed) return true;
    var vid = String(item.variantId);
    var cartQty = cartQtyMap[vid] || 0;
    countMap[vid] = (countMap[vid] || 0) + 1;
    // Keep this slot only if we haven't exceeded what's in cart
    return countMap[vid] <= cartQty;
  });

  // Top up: if cart qty for an allowed variant exceeds tracked committed slots
  // (e.g. user increased qty in cart drawer), add the difference. These are
  // genuinely in the cart, so mark them committed.
  Object.keys(cartQtyMap).forEach(function (vid) {
    if (cfg && cfg.allowedVariantIds && cfg.allowedVariantIds.indexOf(parseInt(vid, 10)) === -1) return;

    var trackedCount = result.filter(function (item) {
      return String(item.variantId) === vid && item.committed;
    }).length;
    var cartQty = cartQtyMap[vid];

    if (cartQty > trackedCount) {
      var ci = cartDataMap[vid];
      var maxAllowed = cfg ? cfg.max : Infinity;
      var toAdd = Math.min(cartQty - trackedCount, maxAllowed - result.length);
      for (var i = 0; i < toAdd; i++) {
        result.push({
          variantId: vid,
          img: ci.image || '',
          title: ci.product_title || ci.title || '',
          committed: true
        });
      }
    }
  });

  return result;
}

// If something outside the bundle bar (cart drawer, cart page, /cart/change
// call from elsewhere) drops the committed quantity below cfg.min, this pulls
// the rest of the bundle's committed items out of the real cart too, so a lone
// sock never sits there. Returns the item list with those committed items
// stripped out (they're no longer in the cart, so no longer tracked).
function enforceMinimumInCart(items, cfg) {
  var committedCount = items.filter(function (it) { return it.committed; }).length;
  if (committedCount === 0 || committedCount >= cfg.min) return items;

  var vidsToClear = {};
  items.forEach(function (it) {
    if (it.committed) vidsToClear[String(it.variantId)] = true;
  });

  Promise.all(Object.keys(vidsToClear).map(function (vid) {
    return _fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: vid, quantity: 0 })
    }).then(function (r) { return r.json(); }).catch(function () { return null; });
  })).then(function (results) {
    var lastCart = results[results.length - 1];
    if (lastCart) {
      updateKnownCartItems(lastCart.items || []);
      document.querySelectorAll('[data-cart-count], .cart-count-bubble span').forEach(function (el) {
        el.textContent = lastCart.item_count;
      });
    }
  });

  // Items that fell below the minimum are no longer in the cart, but they
  // should still be selectable/visible in the bundle bar — just as pending
  // (uncommitted) picks rather than dropped entirely.
  return items.map(function (it) {
    if (it.committed) {
      return { variantId: it.variantId, img: it.img, title: it.title, committed: false, isFree: it.isFree };
    }
    return it;
  });
}

// ── Sitewide bundle registry ──
// Lets the cart-mutation watcher below enforce "no lone sock" rules on ANY
// page (cart drawer on the homepage, the /cart page, etc.) — not just on
// pages where a bundle bar is actually rendered. Each bundle page registers
// its own rules here the moment it loads.
var CONFIG_REGISTRY_KEY = 'bundle_bar_config_registry';

function loadConfigRegistry() {
  try { return JSON.parse(localStorage.getItem(CONFIG_REGISTRY_KEY) || '{}'); }
  catch (e) { return {}; }
}
function registerBundleConfig(cfg) {
  if (!cfg || !cfg.allowedVariantIds || !cfg.allowedVariantIds.length) return;
  var storageKey = cfg.storageKey || DEFAULT_STORAGE_KEY;
  try {
    var registry = loadConfigRegistry();
    // Merge rather than overwrite: a product page registers only its OWN
    // variant ids (scoped on purpose), which would otherwise clobber the
    // wider variant list a collection page already registered for the same
    // storageKey. Merging keeps the sitewide "no lone sock" check aware of
    // every variant that belongs to this bundle, regardless of which page
    // last loaded.
    var existing = registry[storageKey];
    var mergedIds = cfg.allowedVariantIds.slice();
    if (existing && existing.allowedVariantIds) {
      existing.allowedVariantIds.forEach(function (vid) {
        if (mergedIds.indexOf(vid) === -1) mergedIds.push(vid);
      });
    }
    registry[storageKey] = {
      min: cfg.min,
      mode: cfg.mode || (existing && existing.mode) || null,
      singleItemWarning: cfg.singleItemWarning || (existing && existing.singleItemWarning) || null,
      allowedVariantIds: mergedIds
    };
    localStorage.setItem(CONFIG_REGISTRY_KEY, JSON.stringify(registry));
  } catch (e) {}
}

// Runs on every real cart mutation, on every page. Checks each known bundle's
// actual cart quantity (ground truth from Shopify, not our local tracking) —
// if it's nonzero but under that bundle's minimum, clears it from the cart
// immediately, at the moment the drop happens, regardless of what page you're on.
function enforceAllBundleMinimums(cartItems) {
  var registry = loadConfigRegistry();
  Object.keys(registry).forEach(function (storageKey) {
    var bundleCfg = registry[storageKey];
    if (!bundleCfg.allowedVariantIds || !bundleCfg.allowedVariantIds.length) return;

    var cartQtyForBundle = 0;
    var vidsInCart = [];
    cartItems.forEach(function (ci) {
     if (!isSingleLine(ci) && bundleCfg.allowedVariantIds.indexOf(ci.variant_id) !== -1) {
        cartQtyForBundle += ci.quantity;
          vidsInCart.push(String(ci.key));
      }
    });

    if (cartQtyForBundle > 0 && cartQtyForBundle < bundleCfg.min) {
      Promise.all(vidsInCart.map(function (vid) {
        return _fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: vid, quantity: 0 })
        }).then(function (r) { return r.json(); }).catch(function () { return null; });
      })).then(function (results) {
        var lastCart = results[results.length - 1];
        if (lastCart) {
          updateKnownCartItems(lastCart.items || []);
          document.querySelectorAll('[data-cart-count], .cart-count-bubble span').forEach(function (el) {
            el.textContent = lastCart.item_count;
          });
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      });

      // Keep local tracking in sync so a later visit to the bundle page
      // doesn't show stale filled slots for items no longer in the cart —
      // demote them to pending instead of dropping them so they're still
      // visible in the bar.
      try {
        var stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
        var demoted = stored.map(function (it) {
          if (it.committed) {
            return { variantId: it.variantId, img: it.img, title: it.title, committed: false, isFree: it.isFree };
          }
          return it;
        });
        localStorage.setItem(storageKey, JSON.stringify(demoted));
      } catch (e) {}
    }
  });
}

 var _fetch = window.fetch;

// ── Network-level "sold as a set" gate ──
// The DOM click-interceptors further down (on the remove button and the
// quantity minus stepper) only work if THIS script sees the click before
// whatever else is wired to that button. Any faster event (mousedown/
// pointerdown) or any direct fetch call issued by other cart JS (e.g. an
// optimistic-UI rewrite of the cart page) races past them and the real
// /cart/change.js call goes out before we ever get a chance to confirm.
// Gating the fetch call itself instead of the DOM event closes that race:
// no matter what triggers a cart change, it still has to go through
// window.fetch to actually reach Shopify, so this always sees it first.
var _lastKnownCartItems = [];
function updateKnownCartItems(items) {
  if (items) _lastKnownCartItems = items;
}
_fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
  updateKnownCartItems(cart.items || []);
}).catch(function () {});

function parseChangeBody(opts) {
  if (!opts || !opts.body) return null;
  try { return JSON.parse(opts.body); } catch (e) { return null; }
}

// Resolves a /cart/change.js request body ({line, quantity} or {id, quantity})
// against the last known cart snapshot to find which variant is being changed
// and what its quantity would become.
function resolveChangeTarget(body) {
  if (!body || typeof body.quantity === 'undefined') return null;

  if (typeof body.line !== 'undefined') {
    var idx = parseInt(body.line, 10) - 1;
    var lineItem = _lastKnownCartItems[idx];
    return lineItem ? { variantId: lineItem.variant_id, newQuantity: body.quantity, isSingle: isSingleLine(lineItem) } : null;
  }
  if (typeof body.id !== 'undefined') {
    var idStr = String(body.id);
    var li = _lastKnownCartItems.filter(function (it) { return String(it.key) === idStr; })[0] ||
             _lastKnownCartItems.filter(function (it) { return String(it.variant_id) === idStr; })[0];
    if (li) return { variantId: li.variant_id, newQuantity: body.quantity, isSingle: isSingleLine(li) };
  }
  return null;
}

// If this change would drop a non-BXGY bundle to a nonzero quantity below its
// minimum, intercepts the request: shows the confirm modal, and only lets the
// real network call through based on the user's choice. Returns null (meaning
// "proceed normally, nothing to gate") when no bundle is affected or the
// change is fine as-is.
var _bundleGateBypass = false;
function maybeGateCartChange(opts) {
  if (_bundleGateBypass) return null;

  var target = resolveChangeTarget(parseChangeBody(opts));
  if (!target || target.isSingle) return null;

  var registry = loadConfigRegistry();
  var bundleCfg = null;
  Object.keys(registry).forEach(function (key) {
    var entry = registry[key];
    if (entry.allowedVariantIds && entry.allowedVariantIds.indexOf(target.variantId) !== -1) {
      bundleCfg = entry;
    }
  });
  if (!bundleCfg || bundleCfg.mode === 'bxgy') return null;

  var currentOtherQty = 0;
  var vidsInBundle = {};
  _lastKnownCartItems.forEach(function (ci) {
    if (!isSingleLine(ci) && bundleCfg.allowedVariantIds.indexOf(ci.variant_id) !== -1) {
      vidsInBundle[String(ci.variant_id)] = true;
      if (ci.variant_id !== target.variantId) currentOtherQty += ci.quantity;
    }
  });
  vidsInBundle[String(target.variantId)] = true;

  var resultingQty = currentOtherQty + (parseInt(target.newQuantity, 10) || 0);
  if (resultingQty <= 0 || resultingQty >= bundleCfg.min) return null; // fine, let it through

  return new Promise(function (resolve) {
    showMinConfirm(bundleCfg, function onConfirm() {
      // Confirmed: clear every variant in this bundle for real (via the
      // ORIGINAL fetch, so this doesn't re-enter and re-trigger this same
      // gate), then reload so the whole page reflects the true cart state —
      // this also undoes any optimistic DOM removal other cart JS may have
      // already applied.
      _bundleGateBypass = true;
      Promise.all(Object.keys(vidsInBundle).map(function (vid) {
        return _fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: vid, quantity: 0 })
        }).then(function (r) { return r.json(); }).catch(function () { return null; });
      })).then(function (results) {
        var lastCart = results[results.length - 1];
        if (lastCart) updateKnownCartItems(lastCart.items || []);
        _bundleGateBypass = false;
        window.location.reload();
      });
    }, function onCancel() {
      // Cancelled: nothing should change. Resolve the caller's original fetch
      // with the CURRENT (unchanged) cart, then reload to restore any
      // optimistic DOM state other cart JS may have already applied ahead
      // of this gate (e.g. hiding the row before the network call landed).
      _fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        updateKnownCartItems(cart.items || []);
        resolve(new Response(JSON.stringify(cart), {
          status: 200,
          headers: { 'Content-Type': 'application/json' }
        }));
        window.location.reload();
      }).catch(function () {
        resolve(new Response('{}', { status: 200, headers: { 'Content-Type': 'application/json' } }));
        window.location.reload();
      });
    });
  });
}

  window.fetch = function (url, opts) {
    if (typeof url === 'string') {
      var isChangeUrl = url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1;
      if (isChangeUrl) {
        var gate = maybeGateCartChange(opts);
        if (gate) return gate; // blocked pending user confirmation — real fetch not sent yet
      }
    }

    var result = _fetch.apply(this, arguments);
    if (typeof url === 'string') {
      var isChange = url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1;
      var isAdd = url.indexOf('/cart/add.js') !== -1;

      // Sitewide, page-independent: runs no matter what page the mutation
      // happened on (cart drawer, /cart page, wherever).
      if (isChange) {
        result.then(function (r) {
          r.clone().json().then(function (cart) {
            updateKnownCartItems(cart.items || []);
            enforceAllBundleMinimums(cart.items || []);
          }).catch(function () {});
        }).catch(function () {});
      }
      if (isAdd) {
        result.then(function (r) {
          r.clone().json().then(function (data) {
            if (!data.status) {
              // /cart/add.js only returns the added line, not the full cart —
              // grab a fresh snapshot to check the bundle's real total.
              _fetch('/cart.js').then(function (rr) { return rr.json(); }).then(function (freshCart) {
                updateKnownCartItems(freshCart.items || []);
                enforceAllBundleMinimums(freshCart.items || []);
              }).catch(function () {});
            }
          }).catch(function () {});
        }).catch(function () {});
      }
    }

    // Only intercept for the page-specific bundle bar UI if it's active on this page
    if (typeof url === 'string' && window.BundleBarConfig) {
      if (url.indexOf('/cart/add.js') !== -1) {
        result.then(function (r) {
          r.clone().json().then(function (data) {
          if (!data.status && !_suppressBundleCartAdd) {
              if (window._bundleCartAddPending) return;
              window._bundleCartAddPending = true;
              setTimeout(function () { window._bundleCartAddPending = false; }, 3000);
              console.log('[BundleBar] bundle:cart-add fired, productPage=', window.BundleBarConfig && window.BundleBarConfig.productPage);
              document.dispatchEvent(new CustomEvent('bundle:cart-add', { bubbles: true }));
            }
          }).catch(function () {});
        }).catch(function () {});
      }
      if (url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1) {
        result.then(function (r) {
          r.clone().json().then(function (cart) {
            document.dispatchEvent(new CustomEvent('bundle:cart-change', {
              bubbles: true,
              detail: { cart: cart }
            }));
          }).catch(function () {});
        }).catch(function () {});
      }
    }
    return result;
  };

  document.addEventListener('DOMContentLoaded', function () {
    var cfg = window.BundleBarConfig;
    if (!cfg) return;

    registerBundleConfig(cfg);

    var STORAGE_KEY = cfg.storageKey || DEFAULT_STORAGE_KEY;

    var bar = document.getElementById('bundle-bar');
    var saleEl = document.getElementById('bundle-bar-sale');
    var mrpEl = document.getElementById('bundle-bar-mrp');
    var pricingEl = document.getElementById('bundle-bar-pricing');
    var savingsEl = document.getElementById('bundle-bar-savings');
    var noteEl = document.getElementById('bundle-bar-note');
    var nudgeEl = document.getElementById('bundle-bar-nudge');
    var checkoutBtn = document.getElementById('bundle-bar-checkout');
    var slotsEl = document.getElementById('bundle-bar-slots');

    if (!bar || !checkoutBtn) return;

    var selected = [];

    // ── "Fly to bundle bar" animation ──
    // Clones a small thumbnail of the added product and animates it flying
    // from wherever the user clicked (grid card, product-add button, or the
    // product image) into the bundle bar, landing on whichever slot just got
    // filled. Shared by both the socks (tier) bar and the earrings (BXGY) bar.
    var _flyStylesInjected = false;
    function ensureFlyStyles() {
      if (_flyStylesInjected) return;
      _flyStylesInjected = true;
      var style = document.createElement('style');
      style.textContent =
        '.bundle-bar__fly-clone{position:fixed;z-index:9999;pointer-events:none;' +
        'border-radius:8px;object-fit:cover;box-shadow:0 4px 14px rgba(0,0,0,.25);' +
        'transition:top .9s cubic-bezier(.22,.8,.25,1),left .5s cubic-bezier(.22,.8,.25,1),' +
        'width .5s cubic-bezier(.22,.8,.25,1),height .5s cubic-bezier(.22,.8,.25,1),opacity .5s ease;}' +
        '@keyframes bundleBarSlotPop{0%{transform:scale(1);}45%{transform:scale(1.16);}100%{transform:scale(1);}}' +
        '.bundle-bar__slot--pop{animation:bundleBarSlotPop .35s ease;}';
      document.head.appendChild(style);
    }

    // sourceEl: element to fly FROM (its current on-screen position/size is used as the start point)
    // imgSrc: optional explicit image URL for the clone; falls back to sourceEl's own <img> src
    function flyToBundleBar(sourceEl, imgSrc) {
      if (!sourceEl || !bar) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var srcRect = sourceEl.getBoundingClientRect();
      if (!srcRect.width || !srcRect.height) return;

      var src = imgSrc ||
        (sourceEl.tagName === 'IMG' ? sourceEl.src : (sourceEl.querySelector('img') ? sourceEl.querySelector('img').src : ''));
      if (!src) return;

      ensureFlyStyles();

      // Land on whichever slot is currently the last filled one (the one that
      // was just added), falling back to the bar itself if none is found yet.
      var slots = bar.querySelectorAll('.bundle-bar__slot.is-filled');
      var targetEl = slots.length ? slots[slots.length - 1] : bar;
      var targetRect = targetEl.getBoundingClientRect();

      var clone = document.createElement('img');
      clone.src = src;
      clone.className = 'bundle-bar__fly-clone';
      clone.style.top = srcRect.top + 'px';
      clone.style.left = srcRect.left + 'px';
      clone.style.width = srcRect.width + 'px';
      clone.style.height = srcRect.height + 'px';
      clone.style.opacity = '1';
      document.body.appendChild(clone);

      // Force reflow so the transition animates FROM the start position
      // rather than jumping straight to the end.
      clone.getBoundingClientRect();

      requestAnimationFrame(function () {
        var endW = 26, endH = 26;
        clone.style.top = (targetRect.top + targetRect.height / 2 - endH / 2) + 'px';
        clone.style.left = (targetRect.left + targetRect.width / 2 - endW / 2) + 'px';
        clone.style.width = endW + 'px';
        clone.style.height = endH + 'px';
        clone.style.opacity = '0.5';
      });

      var cleaned = false;
      var cleanup = function () {
        if (cleaned) return;
        cleaned = true;
        if (clone.parentNode) clone.parentNode.removeChild(clone);
        if (targetEl && targetEl.classList) {
          targetEl.classList.add('bundle-bar__slot--pop');
          setTimeout(function () { targetEl.classList.remove('bundle-bar__slot--pop'); }, 400);
        }
      };
      clone.addEventListener('transitionend', cleanup, { once: true });
      setTimeout(cleanup, 1400); // fallback in case transitionend doesn't fire
    }

    // Flat per-unit rate that kicks in once quantity exceeds the last fixed tier.
    var FLAT_TIER_MIN = 9;   // first quantity the flat rate applies to
    var FLAT_UNIT_SALE = 299;
    var FLAT_UNIT_MRP = 449;

    // ── BXGY helpers (earrings Buy X Get Y Free) ──
    function getPaidCount(items) {
      return items.filter(function (it) { return !it.isFree; }).length;
    }
    function getFreeCount(items) {
      return items.filter(function (it) { return it.isFree; }).length;
    }
    // How many free entitlements the customer has earned but not yet claimed
    // How many free items are entitled right now, given paid count and the schedule
    function getBxgyState(items, cfg) {
      var paid = getPaidCount(items);
      var free = getFreeCount(items);
      var schedule = cfg.bxgy.schedule;

      var entitled = 0;
      for (var i = 0; i < schedule.length; i++) {
        if (paid >= schedule[i].paid) entitled = schedule[i].free;
      }
      var maxFree = schedule[schedule.length - 1].free;
      entitled = Math.min(entitled, maxFree);

      return {
        paid: paid,
        free: free,
        entitled: entitled,
        unclaimed: Math.max(0, entitled - free),
        maxFree: maxFree
      };
    }

    // How many gift-box PREVIEWS should be shown right now. This is
    // intentionally stricter than raw `unclaimed` — a preview only appears
    // exactly when paid count lands ON a schedule threshold. Once another
    // paid item is added past that threshold (but before the next one),
    // the preview hides again, even though `unclaimed` is still > 0.
    // This keeps the "Add 1 more and get 2 free" message and the visible
    // gift boxes in sync (previously the box lingered in the wrong slot).
    function getBxgyPreviewCount(items, cfg) {
      var state = getBxgyState(items, cfg);
      var schedule = cfg.bxgy.schedule;

      var reachedTier = null;
      for (var i = 0; i < schedule.length; i++) {
        if (state.paid >= schedule[i].paid) reachedTier = schedule[i];
      }
      var atExactThreshold = reachedTier && (state.paid === reachedTier.paid);

      return atExactThreshold ? state.unclaimed : 0;
    }

    // true = there's at least one claimable free slot right now
    function getAvailableFreeSlot(items, cfg) {
  var state = getBxgyState(items, cfg);
  var lastTier = cfg.bxgy.schedule[cfg.bxgy.schedule.length - 1];
  return state.paid >= lastTier.paid && state.unclaimed > 0;
}

    // Builds the ordered slot sequence from the schedule, e.g.
    // [paid, paid, free, paid, free, free] for the 2-tier schedule above.
    function getBxgySlotSequence(cfg) {
      var schedule = cfg.bxgy.schedule;
      var seq = [];
      var prevPaid = 0, prevFree = 0;
      schedule.forEach(function (tier) {
        for (var p = 0; p < (tier.paid - prevPaid); p++) seq.push({ type: 'paid' });
        for (var g = 0; g < (tier.free - prevFree); g++) seq.push({ type: 'free' });
        prevPaid = tier.paid;
        prevFree = tier.free;
      });
      return seq;
    }

    // Grows/shrinks the rendered slot-wrap elements to match how many should
    // currently be visible.
    function ensureBxgySlots(n) {
      var extra = document.getElementById('bundle-bar-extra-slots');
      if (!extra) return;
      var currentCount = extra.children.length;
      if (n > currentCount) {
        for (var i = currentCount; i < n; i++) {
          var wrap = document.createElement('div');
          wrap.className = 'bundle-bar__slot-wrap bundle-bar__slot-wrap--single';
          var slot = document.createElement('div');
          slot.className = 'bundle-bar__slot bundle-bar__slot--single';
          slot.setAttribute('data-slot', i + 1);
          wrap.appendChild(slot);
          extra.appendChild(wrap);
        }
      } else if (n < currentCount) {
        for (var j = currentCount - 1; j >= n; j--) {
          extra.removeChild(extra.children[j]);
        }
      }
    }

    // Message copy driven directly by the schedule:
    // "Add 1 more and get 1 free" → "Claim your free gift!" →
    // "Add 1 more and get 2 free" → "Claim your 2 free gifts!" →
    // "Claim your free gift!" → "Hurray! You claimed 3 free gifts!"
    function getBxgyMessage(items, cfg) {
  var s = getBxgyState(items, cfg);
  var schedule = cfg.bxgy.schedule;

  if (s.free >= s.maxFree) {
    return "🎉 Hurray! You claimed " + s.maxFree + (s.maxFree === 1 ? " free gift!" : " free gifts!");
  }

  var reachedTier = null;
  for (var i = 0; i < schedule.length; i++) {
    if (s.paid >= schedule[i].paid) reachedTier = schedule[i];
  }
  var atExactThreshold = reachedTier && (s.paid === reachedTier.paid);

  if (atExactThreshold && s.unclaimed > 0) {
    if (s.free > 0) {
      return "🎉 Claim your another free gift!";
    }
    return s.unclaimed > 1 ? ("🎉 Claim your " + s.unclaimed + " free gifts!") : "🎉 Claim your free gift!";
  }

  for (var j = 0; j < schedule.length; j++) {
    if (s.paid < schedule[j].paid) {
      var needed = schedule[j].paid - s.paid;
      var newFree = schedule[j].free;
      return "Add " + needed + " more and get " + newFree + " free";
    }
  }
  return "";
}
    function getTier(n) {
  if (cfg.pairPricing) {
    if (n < 2) return null;
    var pairCount = n - (n % 2); // 3→2, 5→4, 6→6
    var base = cfg.tiers.find(function (t) { return t.count === pairCount; });
    if (!base) return null;
    var perSale = base.sale / base.count;
    var perMrp = base.mrp / base.count;
    return {
      count: n,
      sale: Math.round(perSale * n),
      mrp: Math.round(perMrp * n),
      save: Math.round((perMrp - perSale) * n)
    };
  }
  if (n < 2) return null;
  if (n >= FLAT_TIER_MIN) {
    // Beyond the last fixed tier: flat ₹299/sock, scales linearly with quantity
    return {
      count: n,
      sale: FLAT_UNIT_SALE * n,
      mrp: FLAT_UNIT_MRP * n,
      save: (FLAT_UNIT_MRP - FLAT_UNIT_SALE) * n
    };
  }
  return cfg.tiers.find(function (t) { return t.count === n; }) || null;
}
 function ensureExtraSlots(n) {
      var extra = document.getElementById('bundle-bar-extra-slots');
      if (!extra) return;
      var neededCount = Math.max(0, n - 8);
      var currentCount = extra.children.length;
      if (neededCount > currentCount) {
        for (var i = currentCount; i < neededCount; i++) {
          var wrap = document.createElement('div');
          wrap.className = 'bundle-bar__slot-wrap bundle-bar__slot-wrap--single';
          var slot = document.createElement('div');
          slot.className = 'bundle-bar__slot bundle-bar__slot--single';
          slot.setAttribute('data-slot', 8 + i + 1);
          wrap.appendChild(slot);
          extra.appendChild(wrap);
        }
      } else if (neededCount < currentCount) {
        for (var j = currentCount - 1; j >= neededCount; j--) {
          extra.removeChild(extra.children[j]);
        }
      }
    }

    // Batches every not-yet-committed pick into a single real /cart/add.js call.
    // Called once selected.length first reaches cfg.min.
    var _commitInFlight = false;
    var _commitQueued = false;

    function commitPendingItems() {
      if (_commitInFlight) {
        _commitQueued = true;
        return;
      }

      var pending = selected.filter(function (it) { return !it.committed && !it.committing; });
      if (!pending.length) return;

      _commitInFlight = true;
      pending.forEach(function (it) { it.committing = true; });

      var lineItems = pending.map(function (it) {
        return { id: parseInt(it.variantId, 10), quantity: 1 };
      });

      _suppressBundleCartAdd = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: lineItems })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          _suppressBundleCartAdd = false;
          if (data.status) {
            alert(data.description || 'Could not add to cart.');
            // Roll back the picks that failed to actually land in the cart
            selected = selected.filter(function (it) { return it.committed; });
            saveToStorage(STORAGE_KEY, selected);
            _commitInFlight = false;
            render();
            _drainQueuedCommit();
            return;
          }

          pending.forEach(function (it) { it.committed = true; it.committing = false; });
          saveToStorage(STORAGE_KEY, selected);
          render();

         document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (cfg.storageKey === 'bundle_bar_items_earrings') {
            var addedTitle = pending.length ? pending[pending.length - 1].title : '';
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { title: addedTitle } }));
          }
          
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.querySelectorAll('[data-cart-count], .cart-count-bubble span').forEach(function (el) {
                el.textContent = cart.item_count;
              });
            });

          _commitInFlight = false;
          _drainQueuedCommit();
        })
        .catch(function () {
          _suppressBundleCartAdd = false;
          alert('Something went wrong.');
          selected = selected.filter(function (it) { return it.committed; });
          saveToStorage(STORAGE_KEY, selected);
          _commitInFlight = false;
          render();
          _drainQueuedCommit();
        });
    }

    function _drainQueuedCommit() {
      if (_commitQueued) {
        _commitQueued = false;
        commitPendingItems();
      }
    }
    // ── Remove: gate + actual removal ──
    // For non-BXGY bundles (socks), removing a committed item that would drop
    // the bundle below cfg.min now shows a confirmation modal FIRST. Nothing
    // touches the cart until the user confirms "Remove Both" — Cancel leaves
    // everything exactly as it was. This replaces the old behavior where the
    // item was immediately demoted to "pending" and an async /cart/change.js
    // call cleared it a moment later — during that gap the lone item was
    // genuinely still in the cart and checkout-able.
    function removeFromCartAndBundle(variantId, index) {
      var item = selected[index];
      var wasCommitted = !!(item && item.committed);

      if (wasCommitted && cfg.mode !== 'bxgy' && (selected.length - 1) < cfg.min) {
        showMinConfirm(cfg, function () {
          performRemoval(variantId, index);
        });
        return; // Cancel (or awaiting a decision): nothing changes yet
      }

      performRemoval(variantId, index);
    }

    function performRemoval(variantId, index) {
      var item = selected[index];
      var wasCommitted = !!(item && item.committed);

      selected.splice(index, 1);

      if (!wasCommitted) {
        // This pick never made it into the real cart — nothing to undo there
        saveToStorage(STORAGE_KEY, selected);
        render();
        return;
      }

      if (selected.length < cfg.min) {
        // Confirmed (or BXGY, which never gates): pull every remaining
        // committed item for this bundle out of the cart AND drop them from
        // the bar at the same time — both vanish together, nothing lingers
        // as a "pending" leftover.
        //
        // IMPORTANT: use the raw `_fetch` here, not the wrapped `window.fetch`.
        // The user has already confirmed via the modal at this point, so this
        // call must not go back through `maybeGateCartChange` — routing it
        // through the wrapped fetch re-evaluates each variant's removal against
        // the (still-stale, not-yet-updated) `_lastKnownCartItems` snapshot and
        // re-triggers the confirmation gate for whichever variant's request
        // resolves first, so the two removals stop being simultaneous and the
        // second item only clears once the periodic reconciliation catches up
        // a couple seconds later.
        var vidsToClear = {};
        vidsToClear[String(variantId)] = true;
        selected.forEach(function (s) {
          if (s.committed) vidsToClear[String(s.variantId)] = true;
        });

        Promise.all(Object.keys(vidsToClear).map(function (vid) {
          return _fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: vid, quantity: 0 })
          }).then(function (r) { return r.json(); }).catch(function () { return null; });
        })).then(function (results) {
          var lastCart = results[results.length - 1];
          if (lastCart) {
            updateKnownCartItems(lastCart.items || []);
            document.querySelectorAll('[data-cart-count], .cart-count-bubble span').forEach(function (el) {
              el.textContent = lastCart.item_count;
            });
          }
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        });

        if (cfg.mode === 'bxgy') {
          // Unchanged BXGY behavior: keep them tracked as pending picks so
          // they still show in the bundle bar.
          selected.forEach(function (s) { s.committed = false; });
        } else {
          // Socks: confirmed removal means both should actually disappear
          // from the bar, not linger as pending.
          selected = selected.filter(function (s) { return !s.committed; });
        }
        saveToStorage(STORAGE_KEY, selected);
        render();
        return;
      }

      // Still at/above the minimum — just drop this one unit from the cart
      var remainingCount = selected.filter(function (s) {
        return String(s.variantId) === String(variantId) && s.committed;
      }).length;

      _fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: String(variantId), quantity: remainingCount })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateKnownCartItems(cart.items || []);
          document.querySelectorAll('[data-cart-count], .cart-count-bubble span').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function () {});

      saveToStorage(STORAGE_KEY, selected);
      render();
    }

    function render() {
  if (cfg.mode === 'bxgy') {
    renderBxgy();
    return;
  }

  bar.classList.add('is-visible');

  var n = selected.length;
  ensureExtraSlots(n);   // ← add this line

  var slots = bar.querySelectorAll('.bundle-bar__slot');
  var badges = bar.querySelectorAll('.bundle-bar__badge');
  var tier = getTier(n);

      slots.forEach(function (slot, i) {
        var item = selected[i];
        slot.innerHTML = '';
        slot.classList.toggle('is-filled', !!item);

        if (item) {
          var img = document.createElement('img');
          img.src = item.img;
          img.alt = item.title || '';
          img.width = 54;
          img.height = 54;
          img.loading = 'lazy';
          slot.appendChild(img);

          (function (slotIndex, vid) {
            var rm = document.createElement('button');
            rm.className = 'bundle-bar__remove';
            rm.setAttribute('aria-label', 'Remove');
            rm.innerHTML = '&times;';
            rm.addEventListener('click', function (e) {
              e.stopPropagation();
              removeFromCartAndBundle(vid, slotIndex);
            });
            slot.appendChild(rm);
          })(i, item.variantId);

        } else {
          slot.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M8 2v12M2 8h12" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';
        }
      });

      badges.forEach(function (badge, i) {
  if (cfg.pairPricing) {
    var pairEndCount = (i + 1) * 2; // badge 0 → pair ending at 2, badge 1 → 4, badge 2 → 6
    var t = cfg.tiers.find(function (x) { return x.count === pairEndCount; });
    if (!t) { badge.classList.remove('is-visible'); return; }
    badge.textContent = 'SAVE ₹' + (t.mrp - t.sale);
    badge.classList.toggle('is-visible', n >= pairEndCount);
    return;
  }
  // ── original per-slot logic (earrings, untouched) ──
  // ── socks: each pair box shows the savings for its milestone count (2, 4, 6, 8) ──
  // ── socks: each pair box always shows its milestone savings, regardless of quantity ──
  var milestone = (i + 1) * 2;
  var t2 = getTier(milestone);
  if (!t2) { badge.classList.remove('is-visible'); return; }
  badge.textContent = 'SAVE ₹' + (t2.mrp - t2.sale);
  badge.classList.add('is-visible');
});

     if (n >= cfg.min && tier) {
  saleEl.textContent = '₹' + tier.sale;
  mrpEl.textContent = '₹' + tier.mrp;
  if (savingsEl) savingsEl.textContent = n === 8 ? '' : 'YOU SAVED ₹' + (tier.mrp - tier.sale);
  if (noteEl) noteEl.textContent = n >= FLAT_TIER_MIN ? 'Beyond 8, every sock is ₹' + FLAT_UNIT_SALE : '';
  pricingEl.classList.add('is-visible');
} else {
  if (savingsEl) savingsEl.textContent = '';
  if (noteEl) noteEl.textContent = '';
  pricingEl.classList.remove('is-visible');
}

// Nudge: only on odd counts, one slot away from a better tier
// Nudge: targets the next even "pair milestone" (2, 4, 6, 8); congrats once maxed out
// Nudge: targets the next even "pair milestone" (2, 4, 6, 8); congrats only exactly at 8
if (nudgeEl) {
  var nextMilestone = n >= 1 ? (n % 2 === 0 ? n + 2 : n + 1) : null;
  var nextTier = nextMilestone ? getTier(nextMilestone) : null;

  if (nextMilestone && nextTier && nextMilestone <= 8 && n < cfg.max) {
    var more = nextMilestone - n;
    nudgeEl.innerHTML =
  'Add ' + more + ' & save <span class="bundle-save-amount">₹' + nextTier.save + '</span>';
    nudgeEl.classList.add('is-visible');
  } else if (n === 8) {
    var maxTier = getTier(8);
    nudgeEl.innerHTML =
  'Congrats! You saved <span class="bundle-save-amount">₹' + maxTier.save + '</span>';
    nudgeEl.classList.add('is-visible');
  } else {
    nudgeEl.classList.remove('is-visible');
  }
}

      checkoutBtn.disabled = n < cfg.min;
      checkoutBtn.textContent = n >= cfg.min ? 'Checkout' : 'Select min 2 products';
      checkoutBtn.style.fontFamily = '"Barlow Condensed", sans-serif';
   // Auto-scroll the slots row so the most recently filled slot stays in view
      // Auto-scroll the slots row so the most recently filled slot stays in view
if (slotsEl) {
  var filledSlots = slotsEl.querySelectorAll('.bundle-bar__slot.is-filled');
  var scrollTarget = null;

  if (filledSlots.length) {
    var lastFilled = filledSlots[filledSlots.length - 1];
    scrollTarget = lastFilled.closest('.bundle-bar__pair') ||
                   lastFilled.closest('.bundle-bar__slot-wrap--single');
  } else {
    scrollTarget = slotsEl.querySelector('.bundle-bar__pair');
  }

  if (scrollTarget) {
    scrollTarget.scrollIntoView({ behavior: 'smooth', inline: 'end', block: 'nearest' });
  }
}
    }

    // ── BXGY render path (earrings Buy X Get Y Free — bundle-slot UI) ──
    // Bar stays hidden until the first item is added. Real items render
    // strictly in the order they were added (sequential, no gaps). Gift-box
    // previews only appear as trailing slots, and only exactly at a schedule
    // threshold (see getBxgyPreviewCount) — so a mid-flight paid add never
    // strands an empty gift box in between filled slots.
    function renderBxgy() {
      var n = selected.length;

      if (n === 0) {
        bar.classList.remove('is-visible');
        return;
      }
      bar.classList.add('is-visible');

      // Real items render strictly in the order they were added — sequential, no gaps.
      var rows = selected.map(function (it, idx) {
        return { role: it.isFree ? 'free' : 'paid', item: it, selectedIndex: idx };
      });

      // Preview slots for unclaimed free entitlement always trail AFTER real
      // items, and only show right at an exact threshold — they hide again
      // once you add another paid item past it, until the next threshold hits.
      var previewCount = getBxgyPreviewCount(selected, cfg);
      for (var p = 0; p < previewCount; p++) {
        rows.push({ role: 'free', item: null });
      }

      var visibleCount = rows.length;
      ensureBxgySlots(visibleCount);

      var slotWraps = document.querySelectorAll('#bundle-bar-extra-slots .bundle-bar__slot-wrap--single');

      slotWraps.forEach(function (slotWrap, i) {
        var row = rows[i];
        var slot = slotWrap.querySelector('.bundle-bar__slot');
        if (!row) return;

        var isPreviewFree = (row.role === 'free' && !row.item);
        slotWrap.classList.toggle('is-next-free', isPreviewFree);
        slot.classList.toggle('is-filled', !!row.item);
        slot.innerHTML = '';

        if (row.item) {
          var img = document.createElement('img');
          img.src = row.item.img;
          img.alt = row.item.title || '';
          img.loading = 'lazy';
          slot.appendChild(img);

          // Remove (×) button — same pattern as the sock bundle bar's render(),
          // synced to the real cart via removeFromCartAndBundle.
          (function (slotIndex, vid) {
            var rm = document.createElement('button');
            rm.className = 'bundle-bar__remove';
            rm.setAttribute('aria-label', 'Remove');
            rm.innerHTML = '&times;';
            rm.addEventListener('click', function (e) {
              e.stopPropagation();
              removeFromCartAndBundle(vid, slotIndex);
            });
            slot.appendChild(rm);
          })(row.selectedIndex, row.item.variantId);

        } else if (row.role === 'free') {
          slot.innerHTML = '<span class="giftbox__icon" aria-hidden="true">🎁</span>';
        }
      });

      var msgEl = document.getElementById('bundle-bar-bxgy-message');
      if (msgEl) msgEl.textContent = getBxgyMessage(selected, cfg);

      var paid = getPaidCount(selected);
      checkoutBtn.disabled = paid < cfg.min;
      checkoutBtn.textContent = paid >= cfg.min ? 'Checkout' : 'Select min ' + cfg.min + ' products';

      if (slotsEl) {
        var lastWrap = slotWraps[slotWraps.length - 1];
        if (lastWrap) lastWrap.scrollIntoView({ behavior: 'smooth', inline: 'end', block: 'nearest' });
      }
    }

    // Reconciles `selected` against a live cart snapshot, then makes sure a
    // below-minimum leftover (e.g. from deleting one sock in the cart drawer)
    // gets fully cleared out of the cart rather than left dangling.
    function applyReconciliation(cartItems) {
      var reconciled = reconcileWithCart(selected, cartItems, cfg);
      reconciled = enforceMinimumInCart(reconciled, cfg);
      if (reconciled.length !== selected.length ||
          reconciled.some(function (it, i) { return !selected[i] || it.committed !== selected[i].committed; })) {
        selected = reconciled;
        saveToStorage(STORAGE_KEY, selected);
        render();
      }
    }

    function reconcileAndRender() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          applyReconciliation(cart.items || []);
        })
        .catch(function () {});
    }

  function init() {
      var stored = normalizeCommitted(loadFromStorage(STORAGE_KEY));
      if (!stored.length) {
        render();
      } else {
        // Render immediately from localStorage — no waiting
        selected = stored.slice(0, cfg.max);
        // Self-heal: only meaningful on collection pages, where allowedVariantIds
        // covers the whole bundle category. On product pages it's scoped to just
        // that product's variants, so filtering there would wrongly strip other
        // bundle items belonging to different products.
        if (!cfg.productPage) {
          selected = filterToAllowed(selected, cfg);
        }
        render();

      // Reconcile in background silently
        _fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            applyReconciliation(cart.items || []);
          })
          .catch(function () {});
      }
      setInterval(function () {
        if (!selected.length) return;
        if (_justAddedToBundle) return;
        reconcileAndRender();
      }, 3000);
      document.addEventListener('bundle:cart-change', function (e) {
        if (!selected.length) return;
        var cart = e.detail && e.detail.cart;
        if (cart && cart.items) {
          applyReconciliation(cart.items);
        } else {
          reconcileAndRender();
        }
      });

      document.addEventListener('cart:refresh', function () {
        if (!selected.length) return;
        // Don't reconcile immediately after a bundle add — cart may not have settled
        if (_justAddedToBundle) return;
        reconcileAndRender();
      });

     window.addEventListener('focus', function () {
        if (!selected.length) return;
        reconcileAndRender();
      });

      document.addEventListener('bundle:reinit', function() {
        var stored = normalizeCommitted(loadFromStorage(STORAGE_KEY));
        selected = stored.slice(0, cfg.max);
        if (!cfg.productPage) {
          selected = filterToAllowed(selected, cfg);
        }
        render();
      });
    }

    // ── Collection page: quick-add intercept ──
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.quick-add__submit');
      if (!btn || btn.disabled) return;
      if (selected.length >= cfg.max) return;

      var form = btn.closest('form');
      var input = form && form.querySelector('input[name="id"].product-variant-id');
      var variantId = input && input.value;
      if (document.querySelector('.four-tab-layout .tab-panel.is-active[data-tab-panel="tab-1"]')) return;
      if (!variantId) return;

      if (cfg.allowedVariantIds && cfg.allowedVariantIds.indexOf(parseInt(variantId, 10)) === -1) return;

     
      e.preventDefault();
      e.stopImmediatePropagation();

      // FIX: resolve img and title from the product card, not undefined vars
      var card = btn.closest('.card-wrapper, .product-card-wrapper, [data-product-card], li');
      var imgEl = card && card.querySelector('img');
      var img = imgEl ? imgEl.src : '';
      var titleEl = card && card.querySelector('.card__heading a, .card__heading, .full-unstyled-link');
      var title = titleEl ? titleEl.textContent.trim() : '';

      // Track the pick locally first — don't touch the real cart until we hit cfg.min
      var markFree = cfg.mode === 'bxgy' && getAvailableFreeSlot(selected, cfg);
      selected.push({ variantId: variantId, img: img, title: title, committed: false, isFree: markFree });
      saveToStorage(STORAGE_KEY, selected);
      render();
      flyToBundleBar(imgEl || card, img);

      if (selected.length >= cfg.min) {
        commitPendingItems();
      }

      btn.style.transform = 'scale(.85)';
      setTimeout(function () { btn.style.transform = ''; }, 220);
    }, true);

    // ── Product page: detect Dawn's own Add to Cart via fetch intercept ──
// ── Product page: detect Dawn's own Add to Cart via fetch intercept ──
// NOTE: this fires when something OTHER than our own "Add to bundle" button
// hit /cart/add.js successfully — e.g. Dawn's native product-form Add to Cart button.
// That add has already really happened in Shopify's cart by the time we see it.
// If the bundle is still below cfg.min after tracking this pick, we roll the
// real cart line back out (quantity 0 for this add) and keep the item locally
// as a PENDING (uncommitted) pick instead — so it's visible in the bundle bar
// without sitting alone in the cart. It becomes a real cart line again once
// the bundle reaches cfg.min, same as picks made via the "Add to bundle" button.
var _bundleButtonJustPushed = false;

document.addEventListener('bundle:cart-add', function () {
  if (!cfg.productPage) return;
  if (selected.length >= cfg.max) return;

  // Block reconcile immediately — before anything async
  _justAddedToBundle = true;

  // Grab variant id and product data from DOM right now — no waiting
 var variantInput = document.querySelector(
    'form[data-type="add-to-cart-form"] input[name="id"]' +
    (cfg.sectionId ? ', #product-form-' + cfg.sectionId + ' input[name="id"]' : '') +
    ', form.product-form input[name="id"]' +
    ', #MainContent form input[name="id"][type="hidden"]'
  );
  var variantId = variantInput ? variantInput.value : null;

  if (!variantId) {
    // Fallback: slow path via /cart.js
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var imgEl = document.querySelector('.product__media-item img, .product-gallery-desktop img');
        var img = imgEl ? imgEl.src : '';
        var titleEl = document.querySelector('.product__title h1');
        var title = titleEl ? titleEl.textContent.trim() : '';
        var changed = false;
        cart.items.forEach(function (item) {
          if (selected.length >= cfg.max || changed) return;
          if (cfg.allowedVariantIds && cfg.allowedVariantIds.indexOf(item.variant_id) === -1) return;
          var trackedCount = selected.filter(function (s) {
            return String(s.variantId) === String(item.variant_id);
          }).length;
          if (item.quantity > trackedCount) {
            selected.push({ variantId: String(item.variant_id), img: img || item.image, title: title || item.product_title, committed: true });
            saveToStorage(STORAGE_KEY, selected);
            changed = true;
          }
        });
        if (changed) {
          render();
          if (imgEl) flyToBundleBar(imgEl, img);
          if (cfg.storageKey === 'bundle_bar_items_earrings') {
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          }

          if (selected.length < cfg.min) {
            demoteBelowMinimum();
          }
        }
        setTimeout(function () { _justAddedToBundle = false; }, 2000);
      })
      .catch(function () { _justAddedToBundle = false; });
    return;
  }

  // Check allowlist
  if (cfg.allowedVariantIds && cfg.allowedVariantIds.indexOf(parseInt(variantId, 10)) === -1) { 
    _justAddedToBundle = false;
    return;
  }

  // Optimistic push — render immediately with DOM data. This item is already
  // genuinely in the cart (Dawn's own form just added it), so it's committed
  // for now — demoteBelowMinimum() below will roll it back out of the cart
  // if the bundle is still short of cfg.min.
  var imgEl = document.querySelector('.product__media-item img, .product-gallery-desktop img');
  var img = imgEl ? imgEl.src : '';
  var titleEl = document.querySelector('.product__title h1');
  var title = titleEl ? titleEl.textContent.trim() : '';

  var markFree = cfg.mode === 'bxgy' && getAvailableFreeSlot(selected, cfg);
  selected.push({ variantId: String(variantId), img: img, title: title, committed: true, isFree: markFree });
  saveToStorage(STORAGE_KEY, selected);
  render(); // instant
  if (imgEl) flyToBundleBar(imgEl, img);

  if (selected.length < cfg.min) {
    // Below the bundle minimum: this shouldn't sit alone in the real cart.
    // Demote it to a pending pick and pull it back out of the cart so it
    // still shows in the bundle bar without a lone item in the Shopify cart.
    demoteBelowMinimum();
  } else {
    // We've reached (or already were at) the minimum — flush any other
    // still-pending picks (e.g. one added earlier on a collection page)
    // into the cart in the same breath so the whole bundle lands together.
    commitPendingItems();
    setTimeout(function () { _justAddedToBundle = false; }, 1200);
  }

  // Roll a committed-but-below-minimum pick back out of the real cart,
  // keeping it tracked locally as pending so it stays visible in the bar.
  function demoteBelowMinimum() {
    selected.forEach(function (s) { s.committed = false; });
    saveToStorage(STORAGE_KEY, selected);
    render();

    _fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: String(variantId), quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateKnownCartItems(cart.items || []);
        document.querySelectorAll('[data-cart-count], .cart-count-bubble span').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () {});

    setTimeout(function () { _justAddedToBundle = false; }, 1200);
  }
});


// ── Product page / Collection page: "Add to bundle" button ──
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.bundle-bar__product-add');
  if (!btn || btn.disabled) return;
  if (selected.length >= cfg.max) return;

  var variantId = btn.dataset.variantId;
  if (!variantId) return;

  var img = btn.dataset.img || '';
  var title = btn.dataset.title || '';

  // Track the pick locally first. It only becomes a real cart line once the
  // bundle reaches cfg.min — no single-item cart adds from this button anymore.
  var markFree = cfg.mode === 'bxgy' && getAvailableFreeSlot(selected, cfg);
  selected.push({ variantId: variantId, img: img, title: title, committed: false, isFree: markFree });
  saveToStorage(STORAGE_KEY, selected);
  render();
  flyToBundleBar(btn, img);

  btn.textContent = 'Added ✓';
  setTimeout(function () { btn.textContent = btn.dataset.defaultText || 'Add to bundle'; }, 1200);

  if (selected.length >= cfg.min) {
    commitPendingItems();
  }
});

    // ── Checkout ──
    checkoutBtn.addEventListener('click', function () {
      if (this.disabled) return;
      window.location.href = '/checkout';
    });

    init();
  });

  // Re-sync when browser restores page from bfcache
  window.addEventListener('pageshow', function(e) {
    if (!e.persisted) return; // only care about bfcache restores
    var cfg = window.BundleBarConfig;
    if (!cfg) return;
    var bar = document.getElementById('bundle-bar');
    if (!bar) return;

    var STORAGE_KEY = cfg.storageKey || DEFAULT_STORAGE_KEY;

    // Re-render from localStorage immediately
    var stored = normalizeCommitted(loadFromStorage(STORAGE_KEY));
    if (stored.length) {
      // Reconcile with fresh cart in background
      _fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var reconciled = reconcileWithCart(stored, cart.items || [], cfg);
          reconciled = enforceMinimumInCart(reconciled, cfg);
          saveToStorage(STORAGE_KEY, reconciled);
          // Trigger a re-init by dispatching a custom event
          document.dispatchEvent(new CustomEvent('bundle:reinit', { bubbles: true }));
        })
        .catch(function() {});
    }
  });

  // ── Cart page: confirm before removing a below-minimum item ──
  // Shopify's native cart-remove-button (on /cart, and the cart drawer) goes
  // straight to /cart/change.js — it never touches removeFromCartAndBundle,
  // so singleItemWarning in BundleBarConfig never reached it before. This
  // intercepts that click directly, looks the variant up against the
  // sitewide bundle registry (populated by registerBundleConfig on any page
  // that has loaded a bundle bar), and — for non-BXGY bundles only — shows
  // the same confirm modal before letting the removal proceed.
  //
  // NOTE: kept as a defense-in-depth UX nicety (shows the modal a little
  // faster on the plain Dawn cart-item markup), but it is no longer the
  // thing actually protecting the cart — the fetch-level gate above (see
  // maybeGateCartChange) is what guarantees the modal shows and the removal
  // is blocked, regardless of which DOM event or script triggers it.
  function getCartLineFromRemoveEl(removeEl) {
    // Dawn's item.url_to_remove always resolves to /cart/change?line=N&quantity=0,
    // regardless of what the row markup looks like — so this works without
    // needing any custom data attributes in cart-items.liquid.
    var link = removeEl.tagName === 'A' ? removeEl : removeEl.querySelector('a');
    var href = link && link.getAttribute('href');
    if (!href) return null;
    var match = href.match(/[?&]line=(\d+)/);
    return match ? parseInt(match[1], 10) : null;
  }

  // The gate needs to run BEFORE the native remove click fires (Dawn's
  // cart-remove-button has its own click handler that submits the removal
  // immediately). So the real gate runs in the capture phase using a synced
  // snapshot of the cart, refreshed on every cart.js load/refresh event —
  // this avoids a fetch-then-preventDefault race where the removal already
  // started before our async check resolves.
  var _cartSnapshot = null;
  function refreshCartSnapshot() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { _cartSnapshot = cart; })
      .catch(function () {});
  }
  document.addEventListener('DOMContentLoaded', refreshCartSnapshot);
  document.addEventListener('cart:refresh', refreshCartSnapshot);
  document.addEventListener('bundle:cart-change', refreshCartSnapshot);

  document.addEventListener('click', function (e) {
    var removeEl = e.target.closest('cart-remove-button a, cart-remove-button, .cart-remove-button, [data-cart-remove]');
    if (!removeEl) return;
    if (!_cartSnapshot) return; // snapshot not ready yet — let it proceed rather than block removal

    var line = getCartLineFromRemoveEl(removeEl);
    if (!line) return;

    var lineItem = _cartSnapshot.items[line - 1];
    if (!lineItem || isSingleLine(lineItem)) return;

    var registry = loadConfigRegistry();
    var bundleCfg = null;
    Object.keys(registry).forEach(function (key) {
      var entry = registry[key];
      if (entry.allowedVariantIds && entry.allowedVariantIds.indexOf(lineItem.variant_id) !== -1) {
        bundleCfg = entry;
      }
    });

    if (!bundleCfg || bundleCfg.mode === 'bxgy') return;

    var bundleQtyInCart = 0;
    var vidsInBundle = {};
    _cartSnapshot.items.forEach(function (ci) {
      if (!isSingleLine(ci) && bundleCfg.allowedVariantIds.indexOf(ci.variant_id) !== -1) {
        bundleQtyInCart += ci.quantity;
        vidsInBundle[String(ci.variant_id)] = true;
      }
    });
    var remainingAfterRemove = bundleQtyInCart - lineItem.quantity;

    if (remainingAfterRemove <= 0 || remainingAfterRemove >= bundleCfg.min) return; // fine — let native removal happen

    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    showMinConfirm(bundleCfg, function () {
      Promise.all(Object.keys(vidsInBundle).map(function (vid) {
        return _fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: vid, quantity: 0 })
        }).then(function (r) { return r.json(); }).catch(function () { return null; });
      })).then(function () {
        window.location.reload();
      });
    });
  }, true);

  // ── Cart page: also gate the quantity "minus" stepper ──
  // A user can just as easily drop below the minimum by clicking − on the
  // quantity input as by clicking the remove (×) icon. Same lookup (find the
  // remove link in the same row to resolve the cart line), same confirm
  // modal, same "Remove Both" outcome — decrementing one unit of a bundle
  // that's about to fall under cfg.min is treated the same as removing it.
  document.addEventListener('click', function (e) {
    var minusBtn = e.target.closest('button[name="minus"], .quantity__button[name="minus"]');
    if (!minusBtn) return;
    if (!_cartSnapshot) return;

    var row = minusBtn.closest('.cart-item, tr, li, [id*="CartItem"], [id*="cart-item"]') || document;
    var removeEl = row.querySelector('cart-remove-button a, cart-remove-button, .cart-remove-button, [data-cart-remove]');
    var line = removeEl ? getCartLineFromRemoveEl(removeEl) : null;
    if (!line) return;

    var lineItem = _cartSnapshot.items[line - 1];
    if (!lineItem || isSingleLine(lineItem)) return;

    var registry = loadConfigRegistry();
    var bundleCfg = null;
    Object.keys(registry).forEach(function (key) {
      var entry = registry[key];
      if (entry.allowedVariantIds && entry.allowedVariantIds.indexOf(lineItem.variant_id) !== -1) {
        bundleCfg = entry;
      }
    });

    if (!bundleCfg || bundleCfg.mode === 'bxgy') return;

    var bundleQtyInCart = 0;
    var vidsInBundle = {};
    _cartSnapshot.items.forEach(function (ci) {
      if (bundleCfg.allowedVariantIds.indexOf(ci.variant_id) !== -1) {
        bundleQtyInCart += ci.quantity;
        vidsInBundle[String(ci.variant_id)] = true;
      }
    });
    var remainingAfterDecrement = bundleQtyInCart - 1;

    if (remainingAfterDecrement <= 0 || remainingAfterDecrement >= bundleCfg.min) return; // fine — let the stepper proceed

    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    showMinConfirm(bundleCfg, function () {
      Promise.all(Object.keys(vidsInBundle).map(function (vid) {
        return _fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: vid, quantity: 0 })
        }).then(function (r) { return r.json(); }).catch(function () { return null; });
      })).then(function () {
        window.location.reload();
      });
    });
  }, true);
})();
